





import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import { VariantType } from '~/models/app/variant'

export default defineComponent({
  props: {
    variant: {
      type: String as PropType<VariantType>,
      default: null
    }
  },
  setup(props) {
    const { variant } = toRefs(props)

    const rowClasses = computed(() => {
      function variantClasses() {
        if (!variant.value) {
          return []
        }
        return [variant.value]
      }
      return [...variantClasses()]
    })

    return { rowClasses }
  }
})
